"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var Apartment = function Apartment(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon ".concat(className, " d8-svg-").concat(name),
    width: "36",
    height: "34",
    viewBox: "0 0 36 34"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || name), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "none",
    stroke: fill,
    strokeWidth: "2.1875",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M5.28174 15.125V32.625H14.0317V24.9688C14.0317 23.8084 14.4927 22.6956 15.3131 21.8752C16.1336 21.0547 17.2464 20.5938 18.4067 20.5938C19.5671 20.5938 20.6799 21.0547 21.5003 21.8752C22.3208 22.6956 22.7817 23.8084 22.7817 24.9688V32.625H31.5317V15.125"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M2.00049 32.625H34.813"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M2.23107 11.959C2.06424 12.2925 1.98545 12.6632 2.00221 13.0358C2.01896 13.4083 2.1307 13.7705 2.3268 14.0877C2.5229 14.4049 2.79685 14.6668 3.12263 14.8483C3.44841 15.0299 3.8152 15.1251 4.18816 15.125H32.6257C32.9986 15.1251 33.3654 15.0299 33.6912 14.8483C34.017 14.6668 34.2909 14.4049 34.487 14.0877C34.6831 13.7705 34.7948 13.4083 34.8116 13.0358C34.8284 12.6632 34.7496 12.2925 34.5827 11.959L30.4382 6.375H6.37565L2.23107 11.959Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M6.37549 6.375V4.1875C6.37549 3.60734 6.60596 3.05094 7.01619 2.6407C7.42643 2.23047 7.98283 2 8.56299 2H28.2505C28.8306 2 29.387 2.23047 29.7973 2.6407C30.2075 3.05094 30.438 3.60734 30.438 4.1875V6.375"
  })));
};
Apartment.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
Apartment.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = Apartment;